<div class="main-container">
  @if (fg) {
  <form [formGroup]="fg" (submit)="update()">
    <mat-slide-toggle formControlName="active" class="toggle-icon">
      Lifetime <b> {{lifetimeThresholdText}}</b>
    </mat-slide-toggle>
    @if (fg.get('active').value) {
    <div>
      <app-money-v2 formControlName="value"></app-money-v2>
      <table>
        <div>
          <tr>
            <td title="Changes the player's status to SYSTEM_FROZEN">
              <input type="radio" [id]="lifetimeThresholdType + '-freeze'" formControlName="action" value="freeze" />
              <label [for]="lifetimeThresholdType + '-freeze'">Freeze</label>
            </td>
          </tr>
          <tr>
            <td title="Changes the player's status to DEPOSIT_BLOCKED">
              <input
                type="radio"
                [id]="lifetimeThresholdType + '-deposit-block'"
                formControlName="action"
                value="depositBlock" />
              <label [for]="lifetimeThresholdType + '-deposit-block'">Deposit Block</label>
            </td>
          </tr>
          <tr>
            <td title="Applies a timer">
              <input
                type="radio"
                [id]="lifetimeThresholdType + '-account-timer'"
                formControlName="action"
                value="accountTimer" />
              <label [for]="lifetimeThresholdType + '-account-timer'">Apply timer</label>
            </td>
          </tr>
          <tr>
            <td title="Raises JIRA ticket">
              <input type="checkbox" [id]="lifetimeThresholdType + '-jira-ticket'" formControlName="jiraTicket" />
              <label [for]="lifetimeThresholdType + '-jira-ticket'">Raise JIRA</label>
            </td>
          </tr>
        </div>
      </table>
    </div>
    }
    <div class="info-container">
      @if (editMode) { @if (updatingInProgress) {
      <mat-spinner class="display-inline" [diameter]="20"></mat-spinner>
      } @if (!success && !updatingInProgress) {
      <button mat-stroked-button color="primary" type="submit">Save</button>
      } @if (!success && !updatingInProgress) {
      <button mat-icon-button color="accent" type="submit" (click)="toggleEditMode()" matTooltip="Cancel">
        <mat-icon>cancel</mat-icon>
      </button>
      } } @if (!editMode) { @if (!success) {
      <button mat-icon-button color="primary" type="submit" (click)="toggleEditMode()">
        <mat-icon>edit</mat-icon>
      </button>
      } @if (success) {
      <strong class="green">Changes saved</strong>
      } }
    </div>
  </form>
  }
</div>
